import times from 'lodash/times'

import React from 'react'
import type { Playlist } from 'types/playlist'
import AspectRatio from 'components/ui/aspect-ratio'
import Image from 'components/ui/image'
import styles from './index.module.css'

const PLACEHOLDER: React.ReactNode = (
  <svg width="46" height="43" viewBox="0 0 46 43">
    <path
      fill="currentcolor"
      d="M18.5483871 4.77777778C18.1386274 4.77777778 17.8064516 5.13429177 17.8064516 5.57407407L17.8064516 37.4259259C17.8064516 37.8657082 18.1386274 38.2222222 18.5483871 38.2222222 18.9581467 38.2222222 19.2903226 37.8657082 19.2903226 37.4259259L19.2903226 5.57407407C19.2903226 5.13429177 18.9581467 4.77777778 18.5483871 4.77777778zM27.4516129 4.77777778C27.0418533 4.77777778 26.7096774 5.13429177 26.7096774 5.57407407L26.7096774 37.4259259C26.7096774 37.8657082 27.0418533 38.2222222 27.4516129 38.2222222 27.8613726 38.2222222 28.1935484 37.8657082 28.1935484 37.4259259L28.1935484 5.57407407C28.1935484 5.13429177 27.8613726 4.77777778 27.4516129 4.77777778zM23 3.55271368e-15C22.5902403 3.55271368e-15 22.2580645.356513996 22.2580645.796296296L22.2580645 42.2037037C22.2580645 42.643486 22.5902403 43 23 43 23.4097597 43 23.7419355 42.643486 23.7419355 42.2037037L23.7419355.796296296C23.7419355.356513996 23.4097597 3.55271368e-15 23 3.55271368e-15zM5.19354839 17.5185185C4.78378873 17.5185185 4.4516129 17.8750325 4.4516129 18.3148148L4.4516129 24.6851852C4.4516129 25.1249675 4.78378873 25.4814815 5.19354839 25.4814815 5.60330804 25.4814815 5.93548387 25.1249675 5.93548387 24.6851852L5.93548387 18.3148148C5.93548387 17.8750325 5.60330804 17.5185185 5.19354839 17.5185185zM14.0967742 11.1481481C13.6870145 11.1481481 13.3548387 11.5046621 13.3548387 11.9444444L13.3548387 31.0555556C13.3548387 31.4953379 13.6870145 31.8518519 14.0967742 31.8518519 14.5065338 31.8518519 14.8387097 31.4953379 14.8387097 31.0555556L14.8387097 11.9444444C14.8387097 11.5046621 14.5065338 11.1481481 14.0967742 11.1481481zM31.9032258 11.1481481C31.4934662 11.1481481 31.1612903 11.5046621 31.1612903 11.9444444L31.1612903 31.0555556C31.1612903 31.4953379 31.4934662 31.8518519 31.9032258 31.8518519 32.3129855 31.8518519 32.6451613 31.4953379 32.6451613 31.0555556L32.6451613 11.9444444C32.6451613 11.5046621 32.3129855 11.1481481 31.9032258 11.1481481zM9.64516129 14.3333333C9.23540164 14.3333333 8.90322581 14.6898473 8.90322581 15.1296296L8.90322581 27.8703704C8.90322581 28.3101527 9.23540164 28.6666667 9.64516129 28.6666667 10.0549209 28.6666667 10.3870968 28.3101527 10.3870968 27.8703704L10.3870968 15.1296296C10.3870968 14.6898473 10.0549209 14.3333333 9.64516129 14.3333333zM36.3548387 14.3333333C35.9450791 14.3333333 35.6129032 14.6898473 35.6129032 15.1296296L35.6129032 27.8703704C35.6129032 28.3101527 35.9450791 28.6666667 36.3548387 28.6666667 36.7645984 28.6666667 37.0967742 28.3101527 37.0967742 27.8703704L37.0967742 15.1296296C37.0967742 14.6898473 36.7645984 14.3333333 36.3548387 14.3333333zM.741935484 19.1111111C.332175831 19.1111111 2.34923192e-13 19.4676251 2.34923192e-13 19.9074074L2.34923192e-13 23.0925926C2.34923192e-13 23.5323749.332175831 23.8888889.741935484 23.8888889 1.15169514 23.8888889 1.48387097 23.5323749 1.48387097 23.0925926L1.48387097 19.9074074C1.48387097 19.4676251 1.15169514 19.1111111.741935484 19.1111111zM45.2580645 19.1111111C44.8483049 19.1111111 44.516129 19.4676251 44.516129 19.9074074L44.516129 23.0925926C44.516129 23.5323749 44.8483049 23.8888889 45.2580645 23.8888889 45.6678242 23.8888889 46 23.5323749 46 23.0925926L46 19.9074074C46 19.4676251 45.6678242 19.1111111 45.2580645 19.1111111zM40.8064516 17.5185185C40.396692 17.5185185 40.0645161 17.8750325 40.0645161 18.3148148L40.0645161 24.6851852C40.0645161 25.1249675 40.396692 25.4814815 40.8064516 25.4814815 41.2162113 25.4814815 41.5483871 25.1249675 41.5483871 24.6851852L41.5483871 18.3148148C41.5483871 17.8750325 41.2162113 17.5185185 40.8064516 17.5185185z"
    />
  </svg>
)

const getArtwork = (
  artworks: Playlist['tracks_artworks'],
  index: number,
): string => {
  if (artworks && artworks.length > 0) {
    const lastArtwork =
      artworks[artworks.length - 1]?.artwork_sizes?.['160x160'] ?? ''
    return artworks[index]?.artwork_sizes?.['160x160'] ?? lastArtwork
  }

  return ''
}

const renderArtworks = (
  artworks: Playlist['tracks_artworks'],
  optimizeImage,
): React.ReactNode[] =>
  times(3, (index: number) => {
    if (optimizeImage) {
      return (
        <div key={index} className={styles.playlistArtworkArtworksImageStretch}>
          <Image url={getArtwork(artworks, index)} />
        </div>
      )
    }

    return (
      <div
        key={index}
        className={styles.playlistArtworkArtworksImage}
        style={{
          backgroundImage: `url(${getArtwork(artworks, index)})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      />
    )
  })

type Props = {
  color: string | null | undefined
  image?: string | ArrayBuffer | null | undefined
  overlay?: React.ReactNode
  status?: React.ReactNode
  trackArtworks?: Playlist['tracks_artworks']
  optimizeImage?: boolean
}

/**
 * Playlist artwork component that displays either a custom image or a collage of track artworks
 * @param color - Background color for the artwork
 * @param image - Custom playlist image URL or ArrayBuffer
 * @param overlay - Optional overlay content to display on top
 * @param status - Optional status indicator to show below the artwork
 * @param trackArtworks - Array of track artworks to create a collage when no custom image is provided
 * @param optimizeImage - Whether to use optimized image loading
 */
const PlaylistArtwork = ({
  color,
  image,
  overlay,
  status,
  trackArtworks,
  optimizeImage,
}: Props): React.ReactElement<'div'> => (
  <div className={styles.playlistArtwork}>
    <AspectRatio
      fill={color}
      // @ts-expect-error
      image={!optimizeImage ? image : null}
      ratio={3 / 2}
    >
      {image && optimizeImage && (
        <div className={styles.playlistArtworkImage}>
          <Image url={image as string} cover />
        </div>
      )}
      {!color && !image && trackArtworks && trackArtworks.length > 0 ? (
        <div className={styles.playlistArtworkArtworks}>
          {renderArtworks(trackArtworks, optimizeImage).reverse()}
        </div>
      ) : (
        !image && PLACEHOLDER
      )}
      {overlay}
    </AspectRatio>
    {status && <div className={styles.playlistArtworkStatus}>{status}</div>}
  </div>
)

export default PlaylistArtwork
